import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidenavComponent } from './sidenav.component';
import { SvgIconModule } from '../shared/svg-icon/svg-icon.module';
import { RouterModule } from '@angular/router';
import { ToggleButtonModule } from 'app/shared/toggle-button/toggle-button.module';
import { CheckboxModule } from 'app/shared/checkbox/checkbox.module';
import { ThirdPartyModule } from 'app/third-party/third-party.module';

@NgModule({
  declarations: [SidenavComponent],
  imports: [
    CommonModule,
    RouterModule,
    SvgIconModule,
    ToggleButtonModule,
    CheckboxModule,
    FormsModule,
    ThirdPartyModule,
  ],
  entryComponents: [SidenavComponent],
  exports: [SidenavComponent],
})
export class SidenavModule {}
